import { call, put } from '@redux-saga/core/effects';
import { api, notify, formDataBuilder, apiErrorHandler } from 'services';
import {
  CreateInvoiceJustificationActions as Actions,
  CreateInvoiceJustificationRequestAction as RequestAction,
} from 'store/ducks/invoiceJustifications';

export function* createInvoiceJustificationRequest(action: any) {
  const { postData, onSuccess, onFailure }: RequestAction = action;
  try {
    const formData = formDataBuilder(postData);
    yield call(api.post, `invoice/justifications`, formData);
    onSuccess && onSuccess();
    notify('success', 'Justificativa criada com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
